import Vue from 'vue'
import VueRouter from 'vue-router'


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'liuhe',
    redirect: '/zxcount/liuhe'
  },
  {
    path: '/zxcount/liuhe',
    name: 'liuhe',
    meta: { title: '六合统计', titleType: 1 , dataUrl: '/summary.asp'},
    component: () => import('@/components/Summary.vue')
  },
  {
    path: '/zxcount/attribute',
    name: 'attribute',
    meta: { title: '属性参照', titleType: 0 , dataUrl: '/attrConstant.asp'},
    component: () => import('@/components/AttrConstant.vue')
  }, {
    path: '/zxcount/specialcode',
    name: 'specialcode',
    meta: { title: '特码历史冷热图', titleType: 1, dataUrl: '/numberStat.asp', chart1: '特码历史热图（所选期数范围国内出现的次数）', chart2: '特码历史冷图（所选期数范围国内出现的次数）', dataType: 2},
    component: () => import('@/components/echarts/Line.vue')
  }, {
    path: '/zxcount/positivecode',
    name: 'positivecode',
    meta: { title: '正码历史冷热图', titleType: 1, dataUrl: '/numberStat.asp', chart1: '正码历史热图（所选期数范围国内出现的次数）', chart2: '正码历史冷图（所选期数范围国内出现的次数）', dataType: 1},
    component: () => import('../components/echarts/Line.vue')
  }, {
    path: '/zxcount/wstable',
    name: 'wstable',
    meta: { title: '尾数大小统计图', titleType: 2, dataUrl: '/tailBigSmall.asp', yearUrl: '/listYear.asp'},
    component: () => import('../components/Table.vue')
  }, {
    path: '/zxcount/sxpiechart2',
    name: 'sxpiechart2',
    meta: { title: '生肖特码冷热图', titleType: 1, dataUrl: '/animalStat.asp', dataType: 2},
    component: () => import('../components/echarts/Pie.vue')
  }, {
    path: '/zxcount/sxpiechart1',
    name: 'sxpiechart1',
    meta: { title: '生肖正码冷热图', titleType: 1, dataUrl: '/animalStat.asp', dataType: 1},
    component: () => import('../components/echarts/Pie.vue')
  }, {
    path: '/zxcount/bspiechart2',
    name: 'bspiechart2',
    meta: { title: '波色特码冷热图', titleType: 1, dataUrl: '/colorStat.asp', dataType: 2},
    component: () => import('../components/echarts/Pie.vue')
  }, {
    path: '/zxcount/bspiechart1',
    name: 'bspiechart1',
    meta: { title: '波色正码冷热图', titleType: 1, dataUrl: '/colorStat.asp', dataType: 1},
    component: () => import('../components/echarts/Pie.vue')
  }, {
    path: '/zxcount/barchart2',
    name: 'barchart2',
    meta: { title: '特码两面', titleType: 1, dataUrl: '/numberAnalyze.asp', dataType: 2},
    component: () => import('../components/echarts/Bar.vue')
  }, {
    path: '/zxcount/wspiechart2',
    name: 'wspiechart2',
    meta: { title: '特码尾数冷热图', titleType: 1, dataUrl: '/tailStat.asp', dataType: 2},
    component: () => import('../components/echarts/Pie.vue')
  }, {
    path: '/zxcount/wspiechart1',
    name: 'wspiechart1',
    meta: { title: '正码尾数冷热图', titleType: 1, dataUrl: '/tailStat.asp', dataType: 1},
    component: () => import('../components/echarts/Pie.vue')
  }, {
    path: '/zxcount/barchart1',
    name: 'barchart1',
    meta: { title: '正码总分', titleType: 1, dataUrl: '/numberAnalyze.asp', dataType: 1},
    component: () => import('../components/echarts/Bar.vue')
  }, {
    path: '/zxcount/hmpiechart',
    name: 'hmpiechart',
    meta: { title: '号码波段统计图', titleType: 1, dataUrl: '/numberRange.asp', tab: 1},
    component: () => import('../components/echarts/Pie.vue')
  }, {
    path: '/zxcount/jqystable',
    name: 'jqystable',
    meta: { title: '家禽野兽统计图', titleType: 2, dataUrl: '/animalAnalyze.asp', yearUrl: '/listYear.asp'},
    component: () => import('../components/Table.vue')
  }, {
    path: '/zxcount/lmtable',
    name: 'lmtable',
    meta: { title: '连码走势图', titleType: 2, dataUrl: '/consecutiveStat.asp', yearUrl: '/listYear.asp', dataType: 1},
    component: () => import('../components/Table.vue')
  }, {
    path: '/zxcount/lxtable',
    name: 'lxtable',
    meta: { title: '连肖走势图', titleType: 2, dataUrl: '/consecutiveStat.asp', yearUrl: '/listYear.asp', dataType: 2},
    component: () => import('../components/Table.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
